import React, { useEffect, useMemo } from "react";
import {
  Typography, Grid,
} from "@material-ui/core";
import * as wijmo from "@grapecity/wijmo";
import ContractStepper from "../component/portal/contractregist/ContractStepper";
import ContractRegistForm from "../component/portal/contractregist/ContractRegistForm";
import { getCategory, getMember, getMemberList, typeCategory, typeMemberList } from "../api/helpline/master";
import { getAllContractList, getCisDepartmentList, getCisUserList, postContract, typeCisDepartmentList, typeCisUserList, typeContractList } from "../api/helpline/keiyaku";
import { getCustomerList, typeCustomerList } from "../api/helpline/qa";
import { useGlobalState } from "../provider/Provider";
import { valueValidation } from "../validation";

interface Prop {
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleError: (err: any) => void,
  handleClickHome: () => void,
}

export interface typeForm {
  keiyakuNo: string,
  orderNo: string,
  custmNo: string,
  keiyakuStartTs: Date | null,
  keiyakuClsCd: string,
  keiyakuDeposit: string,
  payClsCd: string,
  keiyakuOption: string,
  visitCount: string,
  keiyakuPersonCd: string,
  salesPersonCd: string,
  salesDeptCd: string,
  keiyakuNote: string,
  demandZipCd: string,
  demandAddress: string,
  demandCompanyName: string,
  demandDeptName: string,
  demandPostName: string,
  demandPersonName: string,
  totalPrice: string,
  monthlyPrice: string,
  actionSeDeptCd: string,
  demandNote: string,
  createDate: Date,
  createCd: string,
  updateDate: Date | null,
  updateCd: string,
  custmDepNo: string,
  kaiyakuTs: Date | null,
  machineSettingZipCd: string,
  machineSettingAddress: string,
  incidentDeposit: string,
  incidentCount: string,
  incidentAddCount: string,
  incidentUsedCount: string,
  monthlyPrice2: string,
  mailClsCd: string,
  renewalMonth: number[],
  demandMonth: number[],
  custmName?: string;
}

export interface typeDetailsForm {
  keiyakuDetailNo: string,
  hwType: string,
  hwSerial: string,
  swOs: string,
  swApl: string,
  hwHoshu: string,
  createDate: Date,
  createCd: string,
  updateDate: Date | null,
  updateCd: string,
  virtualEnvflag: boolean,
  virtualOs: string,
  virtualApl: string,
  keiyakuNote: string,
}

const newservice = process.env.REACT_APP_KEIYAKU_NEW_SERVICE!
const appservice = process.env.REACT_APP_KEIYAKU_NEW_APP!

const ContractRegist: React.FC<Prop> = (props) => {
  const { handleError, handleClickHome, handleNotificationOpen } = props
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState

  const [activeStep, setActiveStep] = React.useState<number>(0);
  const todayDate: Date = useMemo(() => new Date(Date.now()), [])
  const [form, setForm] = React.useState<typeForm>({
    keiyakuNo: '',
    orderNo: '',
    custmNo: '',
    keiyakuStartTs: null,
    keiyakuClsCd: '',
    keiyakuDeposit: '',
    payClsCd: '',
    keiyakuOption: '',
    visitCount: '',
    keiyakuPersonCd: '',
    salesPersonCd: '',
    salesDeptCd: '',
    keiyakuNote: '',
    demandZipCd: '',
    demandAddress: '',
    demandCompanyName: '',
    demandDeptName: '',
    demandPostName: '',
    demandPersonName: '',
    totalPrice: '',
    monthlyPrice: '',
    actionSeDeptCd: '',
    demandNote: '',
    createDate: todayDate,
    createCd: userId,
    updateDate: null,
    updateCd: '',
    custmDepNo: '',
    kaiyakuTs: null,
    machineSettingZipCd: '',
    machineSettingAddress: '',
    incidentDeposit: '',
    incidentCount: '',
    incidentAddCount: '',
    incidentUsedCount: '',
    monthlyPrice2: '',
    mailClsCd: '',
    renewalMonth: [],
    demandMonth: [],
  })
  const initdetailsform = useMemo((): typeDetailsForm[] => {
    let detailslist = []
    for (let i = 1; i <= 99; i++) {
      let strNum = ''
      if (i <= 9) {
        strNum = '0' + String(i)
      } else {
        strNum = String(i)
      }
      detailslist.push({
        keiyakuDetailNo: strNum, hwType: '', hwSerial: '', swOs: '', swApl: '', hwHoshu: '', createDate: todayDate, createCd: userId, updateDate: null, updateCd: '', virtualEnvflag: false, virtualOs: '', virtualApl: '', keiyakuNote: '',
      })
    }
    return detailslist
  }, [])
  //契約番号重複msg
  const [errMsg, setErrMsg] = React.useState('')
  //契約詳細
  const [detailsform, setDetailsform] = React.useState<typeDetailsForm[]>(initdetailsform)
  const [reqbasicItem, setReqbasicItem] = React.useState({
    custmNo: true,//顧客名
    custmDepNo: true,//顧客名
    keiyakuNo: true,//契約書番号
    orderNo: true,//受注番号
    keiyakuClsCd: true,//契約項目
    keiyakuStartTs: true,//契約開始日
    renewalMonth: true,//契約更新月
    keiyakuPersonCd: true,//契約担当者
    keiyakuDeposit: true,//契約金額
    totalPrice: true,//合計金額
    machineSettingZipCd: true,//機械設置場所 〒
    machineSettingAddress: true,//機械設置場所 住所
  })
  const [reqinvoiceItem, setReqinvoiceItem] = React.useState({
    demandZipCd: true,//請求先〒
    demandAddress: true,//請求先住所
    demandCompanyName: true,//請求先会社名
    demandPersonName: true,//請求先担当者名
    demandMonth: true,//請求月
    actionSeDeptCd: true,//担当(実施)SEcd
  })
  const [checkinvoiceItem, setCheckinvoiceItem] = React.useState({
    monthlyPrice: true, //請求金額
    monthlyPrice2: true, //請求金額2
    demandZipCd: true,//請求先〒
  })

  const [checkbasicItem, setCheckbasicItem] = React.useState({
    keiyakuNo: true,
    orderNo: true,
    keiyakuDeposit: true,
    totalPrice: true,
    incidentDeposit: true,
    visitCount: true,
    incidentCount: true,
    machineSettingZipCd: true,
  })
  const monthList = useMemo(() => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], [])
  const monthSelect = useMemo(() => [{ value: 'all', name: '毎月' }, { value: 'select', name: '選択月' }], [])
  const [keiyakuStartTs, setKeiyakuStartTs] = React.useState<Date>(todayDate)
  //支払い方法
  const [payment, setPayment] = React.useState<typeCategory[]>([])
  //CIS社員情報
  const [cisUserList, setCisUserList] = React.useState<typeCisUserList[]>([])
  //CIS組織情報
  const [cisDepartmentList, setCisDepartmentList] = React.useState<typeCisDepartmentList[]>([])
  //顧客情報
  const [customerList, setCustomerList] = React.useState<typeCustomerList[]>([])
  //契約項目全取得
  const [contractList, setContractList] = React.useState<typeContractList[]>()
  //選択契約項目
  const [selectKeiyaku, setSelectKeiyaku] = React.useState<typeContractList>()
  //メンバー情報一覧
  const [memberList, setMemberList] = React.useState<typeMemberList[]>([])
  //選択メンバー情報
  const [selectmember, setSelectmember] = React.useState<typeMemberList>()
  const [demandSelect, setDemandSelect] = React.useState<string>('all')
  const [loading, setLoading] = React.useState<boolean>(false)

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const chipDelete = (i: number, name: string) => {
    if (name === "renewalMonth") {
      setForm({
        ...form,
        renewalMonth: form.renewalMonth.filter(value => value !== i),
      })
    } else if (name === "demandMonth") {
      setForm({
        ...form,
        demandMonth: form.demandMonth.filter(value => value !== i),
      })
    }
  }
  const displayIncident = useMemo(() => {
    if (selectKeiyaku) {
      if (selectKeiyaku.keiyakuClsNotes === newservice || selectKeiyaku.keiyakuClsNotes === appservice) {
        return true
      } else {
        return false
      }
    } else { return false }
  }, [selectKeiyaku])

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    if (event.target.name === "renewalMonth" || event.target.name === "demandMonth") {
      setForm({
        ...form,
        [event.target.name as string]: event.target.value as []
      })
    } else {
      setForm({
        ...form,
        [event.target.name as string]: event.target.value as string
      })
    }
    if (event.target.name === "keiyakuNo") { setErrMsg('') }
  }

  const handleChangeCompanyCd = (companyObj: any) => {
    setForm({
      ...form,
      custmNo: companyObj.companyCd,
      custmDepNo: companyObj.departmentCd
    })
  }

  const _onInitialized = (sender: any) => {
    sender.calendar.formatItem.addHandler((sender: any, e: any) => {
      let weekday = e.data.getDay();
      wijmo.toggleClass(e.item, "date-sunday", weekday === 0);
      wijmo.toggleClass(e.item, "date-saturday", weekday === 6);
    })
  }

  const _onValueChanged = (sender: { value: Date }) => {
    setKeiyakuStartTs(sender.value)
  }

  const handleChangeKeiyakuCd = (keiyakuObj: typeContractList) => {
    if (keiyakuObj) {
      setForm({ ...form, keiyakuClsCd: keiyakuObj.keiyakuClsCd })
      setSelectKeiyaku(keiyakuObj)
    } else {
      setForm({ ...form, keiyakuClsCd: '' })
      setSelectKeiyaku(undefined)
    }
  }

  const handleChangeUserCd = (memberObj: typeMemberList) => {
    setForm({
      ...form,
      keiyakuPersonCd: memberObj.userCd,
    })
  };

  const handleChangeSalesPersonCd = (salesPersonCdObj: typeCisUserList | null) => {
    if (salesPersonCdObj && salesPersonCdObj.userCd && salesPersonCdObj.departmentCd) {
      setForm({
        ...form,
        salesPersonCd: salesPersonCdObj.userCd,
        salesDeptCd: salesPersonCdObj.departmentCd
      })
    } else {
      setForm({ ...form, salesPersonCd: '', salesDeptCd: '' })
    }
  };

  const handleChangeDepartmentCd = (departmentObj: typeCisDepartmentList) => {
    setForm({
      ...form,
      actionSeDeptCd: departmentObj.departmentCd
    })
  };

  const handleChangeChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
    let mailclslist = form.mailClsCd.length ? form.mailClsCd.split(',') : []
    if (event.target.checked) {
      if (!mailclslist.includes(event.target.value)) {//配列に値がない場合に追加
        mailclslist.push(event.target.value)
      }
    } else {
      if (mailclslist.includes(event.target.value)) {//配列に値がある場合に削除
        mailclslist = mailclslist.filter(value => value !== event.target.value)
      }
    }
    setForm({ ...form, mailClsCd: mailclslist.join() });
  }

  //ラジオボタンの値に応じて請求月を挿入
  const handleChangeDemandMonth = (event: React.ChangeEvent<HTMLInputElement>) => {
    if ((event.target as HTMLInputElement).value === 'all') {
      setForm({
        ...form,
        demandMonth: monthList
      })
    } else {
      setForm({
        ...form,
        demandMonth: []
      })
    }
  }

  //請求月の値に応じてラジオボタンを制御
  useEffect(() => {
    if (JSON.stringify(form.demandMonth.concat().sort()) === JSON.stringify(monthList.concat().sort())) {
      setDemandSelect('all')
    } else {
      setDemandSelect('select')
    }
  }, [form.demandMonth])

  //Wijmo 日付をformに挿入
  useEffect(() => {
    if (keiyakuStartTs) {
      setForm({
        ...form,
        keiyakuStartTs: keiyakuStartTs
      })
    }
  }, [keiyakuStartTs])

  //初期表示APIコール
  useEffect(() => {
    let cleanup = false
    if (userId && token && role) {
      //顧客情報全取得
      getCustomerList(userId, token, role, '').then(res => { if (!cleanup) { setCustomerList(res) } }).catch(err => handleError(err))
      //契約項目全取得
      getAllContractList(userId, token, role).then(res => { if (!cleanup) { setContractList(res) } }).catch(err => handleError(err))
      //問合わせ方法
      getCategory('payment', userId, token, role).then(res => {
        if (!cleanup) {
          setPayment(res)
          if (res.length !== 0)
            setForm({
              ...form,
              payClsCd: res[0].categoryCd
            })
        }
      }).catch(err => handleError(err))
      //CIS社員情報
      getCisUserList(userId, token, role, '').then(res => { if (!cleanup) { setCisUserList(res) } }).catch(err => handleError(err))
      //CIS組織情報
      getCisDepartmentList(userId, token, role).then(res => { if (!cleanup) { setCisDepartmentList(res) } }).catch(err => handleError(err))
    }
    return () => { cleanup = true }
  }, [userId, token, role])

  //顧客選択後APIコール
  useEffect(() => {
    let cleanup = false
    if (form.custmDepNo) {
      setMemberList([])//契約担当者再表示
      getMemberList(form.custmDepNo, userId, token, role).then(res => {//顧客メンバー取得
        if (!cleanup) {
          setMemberList(res);
          if (res && keiyakuStartTs) {
            let m_adminObj = res.filter(value => value.url)
            setForm({
              ...form,
              keiyakuPersonCd: m_adminObj[0]['userCd'] ? m_adminObj[0]['userCd'] : '',
              keiyakuStartTs: keiyakuStartTs
            })
          }
        }
      })
    }
    return () => { cleanup = true }
  }, [form.custmDepNo])

  useEffect(() => {
    let cleanup = false
    if (displayIncident) {
      if (!cleanup) {
        setForm({
          ...form,
          totalPrice: String(Number(form.keiyakuDeposit) + Number(form.incidentDeposit ? form.incidentDeposit : 0)),
          visitCount: ''
        })
      }
    } else {
      if (!cleanup) {
        setForm({
          ...form,
          totalPrice: form.keiyakuDeposit,
          incidentDeposit: '',
          incidentCount: ''
        })
      }
    }
    return () => { cleanup = true }
  }, [form.keiyakuDeposit, form.incidentDeposit, displayIncident])


  useEffect(() => {
    let cleanup = false
    if (form.keiyakuPersonCd) {
      getMember(userId, token, role, form.keiyakuPersonCd).then(res => {
        if (res && !cleanup) {
          setSelectmember(res)
          setForm({
            ...form,
            demandPersonName: res.userName ? res.userName : '',
            demandDeptName: res.notes ? res.notes.replace(/\|(.*?)$/, '') : '',
            demandPostName: res.notes ? res.notes.replace(/^(.*?)\|/, '') : '',
          })
        }
      }).catch(err => handleError(err))
    }
    return () => { cleanup = true }
  }, [form.keiyakuPersonCd])

  //必須項目&値チェック
  useEffect(() => {
    let cleanup = false
    if (!cleanup) {
      setReqbasicItem({
        ...reqbasicItem,
        custmNo: form.custmNo ? false : true,
        custmDepNo: form.custmDepNo ? false : true,
        keiyakuNo: form.keiyakuNo ? false : true,
        orderNo: form.orderNo ? false : true,
        keiyakuClsCd: form.keiyakuClsCd ? false : true,
        keiyakuStartTs: form.keiyakuStartTs ? false : true,
        renewalMonth: form.renewalMonth.length ? false : true,
        keiyakuPersonCd: form.keiyakuPersonCd ? false : true,
        keiyakuDeposit: form.keiyakuDeposit ? false : true,
        totalPrice: form.totalPrice ? false : true,
        machineSettingZipCd: form.machineSettingZipCd ? false : true,
        machineSettingAddress: form.machineSettingAddress ? false : true,
      })
      setCheckbasicItem({
        ...checkbasicItem,
        keiyakuNo: valueValidation(form.keiyakuNo, 'keiyakuNo'),
        orderNo: valueValidation(form.orderNo, 'orderNo'),
        keiyakuDeposit: valueValidation(form.keiyakuDeposit, 'keiyakuDeposit'),
        totalPrice: valueValidation(form.totalPrice, 'totalPrice'),
        incidentDeposit: valueValidation(form.incidentDeposit, 'incidentDeposit'),
        visitCount: valueValidation(form.visitCount, 'visitCount'),
        incidentCount: valueValidation(form.incidentCount, 'incidentCount'),
        machineSettingZipCd: valueValidation(form.machineSettingZipCd, 'machineSettingZipCd'),
      })
      setReqinvoiceItem({
        ...reqinvoiceItem,
        demandZipCd: form.demandZipCd ? false : true,
        demandAddress: form.demandAddress ? false : true,
        demandCompanyName: form.demandCompanyName ? false : true,
        demandPersonName: form.demandPersonName ? false : true,
        demandMonth: form.demandMonth.length ? false : true,
        actionSeDeptCd: form.actionSeDeptCd ? false : true,
      })
      setCheckinvoiceItem({
        ...checkinvoiceItem,
        monthlyPrice: valueValidation(form.monthlyPrice, 'monthlyPrice'),
        monthlyPrice2: valueValidation(form.monthlyPrice2, 'monthlyPrice2'),
        demandZipCd: valueValidation(form.demandZipCd, 'demandZipCd')
      })
    }
    return () => { cleanup = true }
  }, [form])

  const onSubmit = () => {
    setErrMsg('')
    setLoading(true)
    postContract(userId, token, role, form, detailsform).then(res => {
      setLoading(false)
      if (typeof (res) === 'boolean') {
        handleNotificationOpen('success', '契約の新規登録')
        handleClickHome()
      } else {
        if (res.errMsg) {
          setErrMsg(res.errMsg)
        } else {
          handleError(res)
        }
      }
    }).catch(err => { setLoading(false); handleError(err) })
  }


  return (
    <React.Fragment>
      <Typography variant="h6">契約新規登録</Typography>
      <Grid container spacing={1} justify="center" >
        <Grid item xs={12}>
          <ContractStepper activeStep={activeStep} handleNext={handleNext} handleBack={handleBack} checkbasicItem={checkbasicItem} reqbasicItem={reqbasicItem} reqinvoiceItem={reqinvoiceItem} checkinvoiceItem={checkinvoiceItem} onSubmit={onSubmit} loading={loading} errMsg={errMsg} />
        </Grid>
        <Grid item xs={12}>
          <ContractRegistForm activeStep={activeStep} customerList={customerList} handleChangeCompanyCd={handleChangeCompanyCd} reqbasicItem={reqbasicItem} handleChangeForm={handleChangeForm} form={form} _onValueChanged={_onValueChanged} _onInitialized={_onInitialized} keiyakuStartTs={keiyakuStartTs} contractList={contractList} handleChangeKeiyakuCd={handleChangeKeiyakuCd} monthList={monthList} chipDelete={chipDelete} memberList={memberList} handleChangeUserCd={handleChangeUserCd} payment={payment} cisUserList={cisUserList} handleChangeSalesPersonCd={handleChangeSalesPersonCd} handleChangeChecked={handleChangeChecked} selectmember={selectmember} checkbasicItem={checkbasicItem} selectKeiyaku={selectKeiyaku} detailsform={detailsform} displayIncident={displayIncident} checkinvoiceItem={checkinvoiceItem} reqinvoiceItem={reqinvoiceItem} monthSelect={monthSelect} handleChangeDemandMonth={handleChangeDemandMonth} demandSelect={demandSelect} handleChangeDepartmentCd={handleChangeDepartmentCd} cisDepartmentList={cisDepartmentList} />
        </Grid>
      </Grid>
    </React.Fragment >
  )
}
export default ContractRegist;